import * as React from 'react';
import { RadioGroup as RadioGroupPrimitive } from 'radix-ui';

import { cn } from '@/lib/utils';

/** Design system §6: the group is a plain flex column; spacing is the consumer's call. */
function RadioGroup({ className, ...props }: React.ComponentProps<typeof RadioGroupPrimitive.Root>) {
  return <RadioGroupPrimitive.Root data-slot="radio-group" className={cn('grid gap-2', className)} {...props} />;
}

/**
 * §6: 18px circle, `--border` idle, `--primary` ring and dot when checked, the standard
 * focus ring, and the disabled trio (`--surface-2` fill, `--divider` border).
 */
function RadioGroupItem({ className, ...props }: React.ComponentProps<typeof RadioGroupPrimitive.Item>) {
  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      className={cn(
        'aspect-square size-[18px] shrink-0 cursor-pointer rounded-full border border-border bg-background text-primary transition-[color,box-shadow,border-color] duration-(--animate-duration-hover) ease-(--ease-standard) outline-none',
        'hover:border-border-strong data-[state=checked]:border-primary',
        'focus-visible:ring-focus',
        'disabled:pointer-events-none disabled:border-divider disabled:bg-surface-2 disabled:text-disabled',
        'aria-invalid:border-destructive aria-invalid:focus-visible:ring-focus-destructive',
        className,
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator
        data-slot="radio-group-indicator"
        className="relative flex items-center justify-center"
      >
        <span className="block size-2 rounded-full bg-current" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
}

export { RadioGroup, RadioGroupItem };
